import React from 'react'
import { Link } from 'gatsby'
import styled, { css } from 'styled-components'
import COLORS from '@dabea/common/lib/constants/colors'
import PropTypes from 'prop-types'

const SharedLinkStyle = css`
  color: ${COLORS.BRAND_COLOR_ACCENT};
  font-weight: normal;
  font-size: 1rem;
  font-family: 'Lato', sans-serif;
  margin-top: ${({ sideMenu }) => (sideMenu ? '15px' : '0px')};
  margin-right: 35px;
  position: relative;
  text-decoration: none;

  @media (max-width: 900px) {
    display: none;
  }

  &:active {
    text-decoration: none;
    color: inherit;
  }

  &:focus {
    text-decoration: none;
    color: inherit;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 2px;
    left: 0;
    right: 0;
    width: 100%;
    background-color: ${COLORS.BRAND_COLOR_ACCENT};
    height: 2px;
    border-radius: 2px;
    opacity: 0;
    transform: translateY(7px);
    transition: all 0.3s ease;
  }

  &:hover {
    text-decoration: none;
    color: ${COLORS.BRAND_COLOR_ACCENT};

    &:after {
      opacity: 1;
      transform: translateY(4px);
    }
  }

  &[data-active] {
    &:after {
      opacity: 1;
      background-color: ${COLORS.BRAND_COLOR_ACCENT};
      transform: translateY(4px);
    }
  }

  &[data-menu] {
    color: #fff;
    font-size: 2rem;
    font-weight: 500;

    @media (max-width: 900px) {
      display: block;
    }

    &:after {
      opacity: 0;
      transform: translateY(4px);
    }
  }
`

const StyledLink = styled(Link)`
  ${SharedLinkStyle}
`

const StyledDiv = styled.div`
  cursor: pointer;
  ${SharedLinkStyle}
`

const MenuItem = ({ title, isActive, onClick, href, sideMenu }) => (
  <li style={{ listStyle: 'none', display: 'flex', alignItems: 'center' }}>
    {href ? (
      <StyledLink
        data-active={isActive ? true : undefined}
        data-menu={sideMenu ? true : undefined}
        key="listElement"
        to={href}
      >
        {title}
      </StyledLink>
    ) : (
      <StyledDiv
        data-active={isActive ? true : undefined}
        data-menu={sideMenu ? true : undefined}
        key="listElement"
        onClick={onClick}
      >
        {title}
      </StyledDiv>
    )}
  </li>
)

MenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  href: PropTypes.string,
  sideMenu: PropTypes.bool,
}

MenuItem.defaultProps = {
  href: undefined,
  onClick: undefined,
  sideMenu: false,
}

export default MenuItem
